import { Link } from "react-router";

import { ROUTES } from "@/constants/routes";

export const NotFound = () => (
	<div className="flex h-dvh flex-col items-center justify-center gap-3 p-6 text-center">
		<h1 className="text-primary text-xl font-semibold">Page not found</h1>
		<Link
			className="text-secondary text-sm underline"
			to={ROUTES.ORGANIZATION_MAP}
		>
			Back to Map Configuration
		</Link>
	</div>
);
